import { jsx as b, jsxs as P } from "react/jsx-runtime";
import { useId as $, useState as E, useContext as j, useRef as h, useMemo as B, useEffect as d, useCallback as p, cloneElement as K } from "react";
import { useBreakpointValue as V, useDisclosure as H, useMultiStyleConfig as U, useOutsideClick as Y, Flex as O } from "@chakra-ui/react";
import { defaultGlobalNavContextState as F, GlobalNavContext as L } from "./GlobalNavv2Context.mjs";
import { GlobalNavMenuSlider as q } from "./GlobalNavv2MenuSlider.mjs";
import { MobileSignOutCategory as J } from "./MobileSignOutCategory.mjs";
import { GlobalHeaderv2DevContext as Q } from "../navigation/GlobalHeader/GlobalHeaderv2Context.mjs";
import { getValidChildren as W } from "../../utils/getValidChildren.mjs";
import "react-nanny";
import { focusOnObject as c, isBrowserScrollBarClicked as X } from "./globalNavFunctions.mjs";
const Z = ({
  children: k,
  id: T,
  linkAs: G,
  variant: N = "desktop",
  __TYPE: ee,
  ...D
}) => {
  const g = `gravity-nav-${T || $()}`, I = V({ base: !0, md: !1 }, { fallback: "md" }), r = I ? "mobile" : N, { isOpen: n, onClose: a, onOpen: A } = H(), w = U("GlobalNavv2", { variant: r }), [v, S] = E([]), [e, o] = E(
    F
  ), m = j(Q), _ = h(), f = h(/* @__PURE__ */ new Map()), l = h(/* @__PURE__ */ new Map()), y = B(() => {
    const t = W(k);
    return I && m && t.push(/* @__PURE__ */ b(J, {}, "Sign Out")), t;
  }, [k, I, m]);
  d(() => {
    o({ ...e, focusOnTab: !0 });
  }, []), d(() => {
    e.openCategory !== "" && v.length > 0 && e.focusItem === -1 && o({ ...e, focusItem: 0 });
  }, [e.openCategory, v]), d(() => {
    e.focusItem > -1 && c(l, e.focusItem);
  }, [e.focusItem]), d(() => {
    e.focusCategory > -1 && e.focusOnTab && c(f, e.focusCategory);
  }, [e.focusCategory]);
  const u = p(() => {
    m && m.onMobileMenuClose();
  }, [m]);
  Y({
    ref: _,
    handler: (t) => {
      n && r !== "mobile" && !X(t) && (a(), o({ ...e, openCategory: "", focusItem: -1 }));
    }
  });
  const x = p(
    (t, i) => {
      r === "desktop" && S(i), i.length > 0 ? r === "mobile" && e.openCategory === t.currentTarget.id ? (o({ ...e, openCategory: "" }), a()) : (o({ ...e, openCategory: t.currentTarget.id }), A()) : i.length === 0 && (!t.currentTarget.target && t.currentTarget.innerText !== "Sign Out" && (o({
        ...e,
        activeCategory: t.currentTarget.id,
        openCategory: "",
        activeItem: ""
      }), u()), n && (a(), u()));
    },
    [e]
  ), M = p(
    (t) => {
      const i = new RegExp(`${g}__cat[0-9]+`), C = t.currentTarget.id.match(i), s = { ...e };
      s.openCategory = "", s.focusItem = -1, s.focusCategory = e.focusCategory, t.currentTarget.target || (s.activeCategory = C == null ? void 0 : C[0], s.activeItem = t.currentTarget.id), r === "mobile" ? setTimeout(() => {
        a(), u(), c(f, e.focusCategory), o(s);
      }, 100) : (a(), u(), setTimeout(() => {
        c(f, e.focusCategory);
      }, 100), o(s));
    },
    [e]
  ), R = p(
    (t, i) => {
      if (t.key === "Enter")
        x(t, i);
      else if (t.key === "Tab")
        r !== "mobile" && (a(), o({ ...e, openCategory: "", focusItem: -1 }));
      else {
        if (t.preventDefault(), t.key === "ArrowDown" && (e.focusCategory < y.length - 1 ? r === "mobile" && e.openCategory === t.currentTarget.id ? o({
          ...e,
          focusItem: 0
        }) : o({
          ...e,
          focusCategory: e.focusCategory + 1
        }) : e.focusCategory >= y.length - 1 && (r === "mobile" && e.openCategory === t.currentTarget.id ? o({
          ...e,
          focusItem: 0
        }) : o({ ...e, focusCategory: 0 }))), t.key === "ArrowUp")
          if (e.focusCategory > 0) {
            const C = new RegExp(`${g}__cat([0-9]+)`), s = e.openCategory.match(C);
            r === "mobile" && s !== null && e.focusCategory === parseInt(s[1]) + 1 ? o({
              ...e,
              focusCategory: e.focusCategory - 1,
              focusItem: l.current.size - 1
            }) : o({
              ...e,
              focusCategory: e.focusCategory - 1
            });
          } else
            e.focusCategory <= 0 && o({ ...e, focusCategory: y.length - 1 });
        t.key === "ArrowRight" && r !== "mobile" && n && o({ ...e, focusItem: 0 }), t.key === "Escape" && (r !== "mobile" ? n && (a(), o({ ...e, focusItem: -1 })) : (u(), o({ ...e, focusItem: -1 })));
      }
    },
    [e]
  ), z = p(
    (t) => {
      t.key === "Enter" ? M(t) : t.key === "Tab" ? r !== "mobile" && (t.shiftKey || a(), o({ ...e, focusItem: -1 })) : (t.preventDefault(), t.key === "ArrowDown" && (e.focusItem < l.current.size - 1 ? o({ ...e, focusItem: e.focusItem + 1 }) : e.focusItem === l.current.size - 1 && o(r === "mobile" ? {
        ...e,
        focusCategory: e.focusCategory + 1 < f.current.size ? e.focusCategory + 1 : 0,
        focusItem: -1
      } : { ...e, focusItem: 0 })), t.key === "ArrowUp" && (e.focusItem > 0 ? o({ ...e, focusItem: e.focusItem - 1 }) : e.focusItem === 0 && (r === "mobile" ? (c(f, e.focusCategory), o({ ...e, focusItem: -1 })) : o({ ...e, focusItem: l.current.size - 1 }))), t.key === "ArrowLeft" && r !== "mobile" && (o({ ...e, focusItem: -1 }), c(f, e.focusCategory)), t.key === "Escape" && (r !== "mobile" ? n && (a(), c(f, e.focusCategory), o({ ...e, focusItem: -1 })) : (u(), o({ ...e, focusItem: -1 }))));
    },
    [e]
  );
  return /* @__PURE__ */ b(
    L.Provider,
    {
      value: {
        categoryRefs: f,
        globalNavState: e,
        handleCategoryKeyDown: R,
        handleCategorySelect: x,
        handleItemKeyDown: z,
        handleItemSelect: M,
        itemRefs: l,
        isOpen: n,
        linkAs: G,
        rootId: g,
        setMenuItems: S,
        variant: r
      },
      children: /* @__PURE__ */ P(O, { as: "nav", ref: _, id: g, __css: w.container, ...D, children: [
        /* @__PURE__ */ b(
          O,
          {
            id: `${g}__categories`,
            role: "menubar",
            "aria-label": "Site navigation",
            "aria-orientation": "vertical",
            __css: w.menubar,
            children: y.length > 0 && y.map((t, i) => K(t, {
              index: i
            }))
          }
        ),
        r === "desktop" && /* @__PURE__ */ b(q, { category: e.openCategory, children: v })
      ] })
    }
  );
};
Z.defaultProps = {
  __TYPE: "GlobalNavv2"
};
export {
  Z as GlobalNavv2
};
